import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import { isFunction, addOrRemove } from '@elliemae/ds-utilities/utils';
import { PillGroup } from '../PillGroup.js';
import { RemovablePill } from '../RemovablePill.js';
import { DropdownPill } from '../DropdownPill.js';
import 'react-desc';
import '@elliemae/ds-classnames';
import '@elliemae/ds-shared/FocusGroup/FocusGroupManager';
import '@elliemae/ds-icons/CloseXsmall';
import '@elliemae/ds-shared/FocusGroup/useFocusGroupItem';
import '../Pill.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@elliemae/ds-dropdownmenu';
import '@elliemae/ds-icons/ChevronDown';

function renderMenuItems(options, factory) {
  return options.map(function (option, index) {
    var ItemComponent = factory('radio');

    if (option.type === 'submenu') {
      var SubmenuComponent = factory('submenu');
      var ChildComponent = factory('selection-group');
      return /*#__PURE__*/React.createElement(SubmenuComponent, _extends({}, option, {
        key: option.id,
        item: option
      }), /*#__PURE__*/React.createElement(ChildComponent, _extends({}, option, {
        id: option.id,
        item: option,
        items: option.items,
        itemValueAccessor: function itemValueAccessor(item) {
          return item;
        },
        multi: true
      })));
    }

    return /*#__PURE__*/React.createElement(ItemComponent, _extends({}, option, {
      key: option.id || index,
      item: option
    }));
  });
}

var getSubmenuOptionLabelById = function getSubmenuOptionLabelById(options, id) {
  var index = options.findIndex(function (option) {
    return option.id === id;
  });
  return index ? options[index].label : '';
};

function LabeledDropdownCascadeMenuPill(_ref) {
  _ref.label;
      var options = _ref.options;
      _ref.value;
      var onChange = _ref.onChange,
      onRemove = _ref.onRemove,
      _ref$value = _ref.value,
      selection = _ref$value === void 0 ? {} : _ref$value,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '---' : _ref$placeholder,
      onFocusNextGroup = _ref.onFocusNextGroup,
      onFocusPreviousGroup = _ref.onFocusPreviousGroup,
      onFocusGroupSet = _ref.onFocusGroupSet,
      maxWidth = _ref.maxWidth,
      minWidth = _ref.minWidth,
      menuProps = _objectWithoutProperties(_ref, ["label", "options", "value", "onChange", "onRemove", "value", "placeholder", "onFocusNextGroup", "onFocusPreviousGroup", "onFocusGroupSet", "maxWidth", "minWidth"]);

  var selectionId = Object.keys(selection)[0];
  var selectionValues = selection[selectionId] || '';
  var dropdownLabel = Array.isArray(selectionValues) ? getSubmenuOptionLabelById(options, selectionId) : selectionValues;

  var handleSelectChange = function handleSelectChange(_ref2) {
    var item = _ref2.item,
        group = _ref2.group;

    if (isFunction(onChange)) {
      var nextSelection = group ? _defineProperty({}, group.id, addOrRemove(_toConsumableArray(selection[group.id] || []), item, function (o) {
        return o.id;
      })) : _defineProperty({}, item.id, item.label);
      onChange(nextSelection);
    }
  };

  var removeOption = function removeOption(option) {
    if (isFunction(onChange)) {
      var nextSelection = _defineProperty({}, selectionId, selectionValues.filter(function (val) {
        return option.id !== val.id;
      }));

      onChange(nextSelection);
    }

    onRemove(option);
  };

  return /*#__PURE__*/React.createElement(PillGroup, {
    onFocusGroupSet: onFocusGroupSet,
    onFocusNextGroup: onFocusNextGroup,
    onFocusPreviousGroup: onFocusPreviousGroup
  }, /*#__PURE__*/React.createElement(DropdownPill, _extends({}, menuProps, {
    itemsRenderer: renderMenuItems,
    label: dropdownLabel || placeholder,
    maxWidth: maxWidth,
    minWidth: minWidth,
    onSelectChange: handleSelectChange,
    options: options,
    selection: _defineProperty({}, selectionId, Array.isArray(selectionValues) ? selectionValues.map(function (v) {
      return v.id;
    }) : selectionValues),
    singleGroupSelection: true,
    variant: "title"
  })), Array.isArray(selectionValues) && selectionValues.map(function (option) {
    return /*#__PURE__*/React.createElement(RemovablePill, {
      key: option.id,
      label: option.label,
      onRemove: function onRemove() {
        return removeOption(option);
      }
    });
  }));
}

export default LabeledDropdownCascadeMenuPill;
//# sourceMappingURL=LabeledDropdownCascadeMenuPill.js.map
